<template>
  <div class="followlist">
    <div class="followlist-m">
      <el-form :inline="true" :model="formInline" class="demo-form-inline toolbar" style="padding-bottom: 0px"
        @submit.native.prevent>
        <el-form-item label="设备编号">
          <el-input v-model.trim="formInline.inputdeviceno" placeholder="请输入设备编号" clearable
            @keyup.enter.native.prevent="enterSearchMember"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" plain @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <div v-loading="loading" element-loading-text="拼命加载中......">
        <div class="table-page">
          <el-table :data="list" style="width: 100%" :row-style="tableRowStyle"
            :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="tableHeaderColor">
            <el-table-column label="设备编号" align="center" :show-overflow-tooltip="true">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.deviceNo }}</span>
              </template>
            </el-table-column>
            <el-table-column label="设备名称" :show-overflow-tooltip="true" align="center">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{
                  scope.row.deviceName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column label="设备描述" :show-overflow-tooltip="true" align="center">
              <template slot-scope="scope">
                <span style="margin-left: 10px">{{ scope.row.remark }}</span>
              </template>
            </el-table-column>
            <el-table-column label="绑定位置" :show-overflow-tooltip="true" align="center">
              <template slot-scope="scope">
                <span style="margin-left: 10px; color: orange" v-if="scope.row.location == null">暂未绑定</span>
                <span style="margin-left: 10px" v-else>{{
                  scope.row.location
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="老人姓名"
              :show-overflow-tooltip="true"
              align="center"
            >
              <template slot-scope="scope">
                <span
                  style="margin-left: 10px; color: orange"
                  v-if="
                    scope.row.oldmanName == null && scope.row.location == null
                  "
                  >暂未绑定</span
                >
                <span
                  style="margin-left: 10px; color: red"
                  v-else-if="
                    scope.row.oldmanName == null || scope.row.oldmanName == ''
                  "
                  >无</span
                >
                <span style="margin-left: 10px" v-else>{{
                  scope.row.oldmanName
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
                label="状态"
                 :show-overflow-tooltip="true"
                 align="center"
                >
                <template slot-scope="scope">
                    <span style="margin-left: 10px;color:green;"  v-if="scope.row.online==1">在线</span>
                    <span style="margin-left: 10px;color:red;"  v-else-if="scope.row.online==0">离线</span>
                    <span style="margin-left: 10px"  v-else>在线</span>
                </template>
            </el-table-column>

            <el-table-column label="操作" width="320" align="center">
              <template slot-scope="scope">
                <!-- icon="el-icon-edit" -->
                <el-button type="info" size="mini" plain @click="showLogList(scope.$index, scope.row)">日志</el-button>
                <el-button type="warning" size="mini" plain @click="callRecord(scope.$index, scope.row)">通话记录</el-button>
                <el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row)">修改</el-button>
                <!-- icon="el-icon-delete" -->
                <el-button type="danger" size="mini" plain @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                <!-- <el-button type="primary" size="mini" plain @click="callMohe(scope.$index, scope.row)">呼叫</el-button> -->
              </template>
            </el-table-column>
          </el-table>
        </div>
        <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange"
          :current-page="currentPage" layout="total, prev, pager, next" :total="totalDataNumber" :page-size="pageSize"
          align="center" class="fenye"></el-pagination>
      </div>
      <!-- 弹出新增 -->
      <el-dialog title="新增设备信息" :visible.sync="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" class="followxz" @close="closexz">
        <el-form ref="form" :model="form" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="xzdate">
            <el-input v-model.trim="form.xzdate" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="xzname">
            <el-input v-model.trim="form.xzname" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="xzsec">
            <el-input v-model.trim="form.xzsec" type="textarea" :rows="3" placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="cancelxz">取 消</el-button>
          <el-button type="primary" @click="submitForm('form')" :loading="addLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 弹出修改 -->
      <el-dialog title="修改设备信息" :visible.sync="dialogFormEdit" :close-on-click-modal="false"
        :close-on-press-escape="false" class="followedit">
        <el-form ref="formedit" :model="formedit" :rules="rules">
          <el-form-item label="设备编号" :label-width="formLabelWidth" prop="editdate">
            <el-input disabled v-model.trim="formedit.editdate" auto-complete="off" placeholder="请输入设备编号"></el-input>
          </el-form-item>
          <el-form-item label="设备名称" :label-width="formLabelWidth" prop="editname">
            <el-input v-model.trim="formedit.editname" auto-complete="off" placeholder="请输入设备名称"></el-input>
          </el-form-item>
          <el-form-item label="设备描述" :label-width="formLabelWidth" prop="editsec">
            <el-input v-model.trim="formedit.editsec" auto-complete="off" type="textarea" :rows="3"
              placeholder="请输入设备描述"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="dialogFormEdit = false">取 消</el-button>
          <el-button type="primary" @click="submitFormEdit('formedit')" :loading="editLoading">确 定</el-button>
        </div>
      </el-dialog>

      <!-- 设备日志 -->
      <el-dialog title="设备日志" width="70%" style="margin-top:-80px" 
        :visible.sync="logListVisible" :close-on-click-modal="false">
        <device-log-table :deviceNo="currRecordDeviceNo"></device-log-table>      
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="logListVisible = false">关 闭</el-button>
        </div>
      </el-dialog>


      <!-- 通话记录 -->
      <el-dialog title="通话记录" width="80%" style="margin-top: -10vh;" :visible.sync="callRecordVisible" :close-on-click-modal="false"
        @close="callRecordDialogReset">
        <!-- <div style="color: #606266; font-size: 22px; font-weight: 600;margin-top:-20px">通话次数:{{ callRecordTotal }}</div> -->
        <el-table :data="callRecordList" style="width: 100%" :row-style="tableRowStyle"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }" :header-cell-style="tableHeaderColor">
          <el-table-column prop="deviceNo" label="设备编号" width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="callerMan" label="呼叫人" width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="calleeMan" label="被呼叫人" width="100" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ringingTime" label="响铃时间" width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="answerTime" label="接听时间" width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="hangUpTime" label="挂断时间" width="200" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="ringingDuration" label="响铃时长(s)" width="120" show-overflow-tooltip>
          </el-table-column>
          <el-table-column prop="duration" label="通话时长(s)" width="120" show-overflow-tooltip>
          </el-table-column>
        </el-table>
        <el-pagination background @current-change="callRecordHandleCurrentChange" :current-page="callRecordCurrentPage"
          layout="total, prev, pager, next" :total="callRecordTotal" :page-size="callRecordPageSize" align="center"
          class="fenye" style="margin-top: -20px;"></el-pagination>
        <div slot="footer" class="dialog-footer" style="margin-top: -50px;" align="center">
          <el-button @click.native="callRecordVisible = false">关 闭</el-button>
        </div>
      </el-dialog>

      <!-- 视频通话 -->
      <!-- <el-dialog title="视频通话" width="720px" top="10px" class="magicbox" :visible.sync="videoCallVisible"
        :close-on-click-modal="false" @close="videoCallClose">
        
        <video id="remote" autoplay="1" width="680" height="510" src=""></video>
        <video id="local" autoplay="1"
          style="width: 240px; height: 180px;position: absolute;margin-left: -240px;"></video>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="bye">挂断</el-button>
        </div>
      </el-dialog> -->
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
import deviceLogTable from "@/components/DeviceLogTable";
export default {
  components: { deviceLogTable },
  data() {
    return {
      addLoading: false,
      editLoading: false,
      BindLoading: false,
      connectStatus: 0,
      manageToken:'',
      logListVisible: false,
      currentPage: 1, //初始页
      currRecordDeviceNo:"",
      pageNum: 1, //页码
      pageSize: 10, //每页显示的条数
      deviceno: "",
      list: [], //返回的结果集合
      totalDataNumber: 0, //数据的总数,
      loading: "", //加载数据中
      formInline: {
        inputdeviceno: "",
      },
      // 新增表单dialog
      dialogFormVisible: false,
      dialogVisible: false,
      form: {
        xzdate: "",
        xzsec: "",
        xzname: "",
      },
      formLabelWidth: "120px",
      //修改表单dialog
      dialogFormEdit: false,
      formedit: {
        editdate: "",
        editname: "",
        editsec: "",
      },
      //绑定位置 ， 自定义 老人和床位
      dialogFormBangdi: false,
      locationShow: true, //绑定床位的input 和 span 显示和隐藏的切换
      // isOld: false,
      oldManShow: false, //选择老人的显示和隐藏
      bedShow: false, //选择床位信息的显示和隐藏
      locationBedShow: "", //如果是绑定类型为床位绑定   就把Cascader级联选择器选择的楼栋 层数 房间 床位  回显放到location绑定的位置
      cascadervalue: [], //Cascader级联选择器集合的值默认为空
      optionsBed: [], //床位号的Cascader级联选择器集合
      bindType: 0, //设备绑定的类型
      formBangdi: {
        location: "", //绑定的位置
        deviceId: "", //设备id
        bedId: "", //床位id
        roomId: "", //房间id
        oldmanId: "", //老人姓名
        oldIdCard: "", //身份证号码
        bindDeviceNo: "", //绑定模态框弹出的设备编号
      },
      cascadervalueRoom: [],
      optionsRoom: [], //楼栋层数房间
      RoomShow: false,
      rules: {
        // 新增正则验证匹配规则
        xzdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],
        xzname: [
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        xzsec: [
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
        ],
        editdate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 1, max: 30, message: "长度在 1到 30 个字符" }, //by  guo 2020-4-26-18:12修改
        ],

        editname: [
          //可以设置双重验证标准
          { min: 1, max: 30, message: "长度在 1到 30 个字符" },
        ],
        editsec: [
          { min: 1, max: 100, message: "长度在 1到 100 个字符" },
        ],
        binddate: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
        ],
        location: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "blur", //何事件触发
          },
          { min: 1, max: 15, message: "长度在 1到 15 个字符" },
        ],
        oldmanName: [
          {
            required: true, //是否必填
            message: "不能为空", //规则
            trigger: "change", //何事件触发
          },
        ],
        oldmanId: [
          {
            required: true, //是否必填
            message: "还未选择老人", //规则
            trigger: "change", //何事件触发
          },
        ],
        bedId: [
          {
            required: true, //是否必填
            message: "还未选择床位", //规则
            trigger: "change", //何事件触发
          },
        ],
        roomId: [
          {
            required: true, //是否必填
            message: "还未选择房间", //规则
            trigger: "change", //何事件触发
          },
        ],
      },
      fileFlag: false,
      //网关绑定设备的dialog模态框配置
      deviceId: "",
      pointNo: "",
      oldmanNameList: [],
      deviceType: 28, //全部类型
      serial: "",
      bindOrUnBid: 1,
      chooseMohe: null,
      callStartTime: '',//开始时间
      callAcceptTime: '',//接听时间
      callEndTime: '',//结束时间
      device: "",
      formeditList: {
        deviceId: "",
      },
      value: "25",
      equipmentList: [],
      // 魔盒通话记录
      callRecordVisible: false,
      callRecordAllList: [], // 所有通话记录
      callRecordList: [], // 展示列表
      callRecordCurrentPage: 1, // 第几页
      callRecordTotal: 0,
      callRecordPageSize: 10, // 多少条
      // 通话总时长
      allTime: 0,
      // 视频通话
      videoCallVisible: false,
      currRecordDeviceId:'',
      logList: [],
      logListCurrentPage: 1,
      logListTotal: 0,

    };
  },
  methods: {
    //点击查询
    onSubmit(newVal, oldVal) {
      console.log(newVal, oldVal);
      if (this.formInline.inputdeviceno == "") {
        this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
      } else {
        this.getTableData(
          this.formInline.inputdeviceno,
          (this.pageNum = 1),
          (this.pageSize = 8)
        );
      }
    },
    //键盘事件 按下键盘回车 查询
    enterSearchMember(e) {
      console.log("回车搜索", keyCode, e);
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode == 13 && this.formInline.inputdeviceno != null) {
        if (this.formInline.inputdeviceno == "") {
          this.getTableData(this.formInline.inputdeviceno, (this.pageNum = 1));
        } else {
          this.getTableData(
            this.formInline.inputdeviceno,
            (this.pageNum = 1),
            (this.pageSize = 8)
          );
        }
      }
    },
    // 修改table tr行的背景色
    tableRowStyle({ row, rowIndex }) {
      if (rowIndex % 2 == 0) {
        return "background-color: #ffffff";
      } else {
        return "background-color: #efefef";
      }
    },
    // 修改table header的背景色
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "color:#2d2d2d;font-weight: 600; text-align: center;font-size: 16px;background-color: #efefef;";
      }
    },
    // 点击弹出修改信息的弹窗
    handleEdit(index, row) {
      (this.dialogFormEdit = true), //打开修改弹窗
        console.log(index, row);
      this.listIndex = index; //记录索引
      // this.formedit=row;//记录数据
      this.formedit = Object.assign({}, row); //深拷贝记录
      //将对应行所对的表格值赋给input框
      this.$set(this.formedit, "editdate", row.deviceNo);
      this.$set(this.formedit, "editsec", row.remark);
      this.$set(this.formedit, "editname", row.deviceName);
    },
    //点击修改弹窗的 确定按钮提交修改的数据
    submitFormEdit(datainfo) {
      //正则匹配规则rules
      this.$refs[datainfo].validate((valid) => {
        //判断数据是否存在
        if (valid) {
          let param = {
            // deviceId: this.formedit.deviceId,
            id: this.formedit.id,
            remark: this.formedit.editsec,
            deviceName: this.formedit.editname
          };
          console.log(param);
          this.editLoading = true;
          this.$postJson("dmc/commonDevice/edit", param).then((res) => {
            console.log(res);
            this.editLoading = false;
            this.dialogFormEdit = false; //关闭修改弹窗
            this.$bus.$emit("submitFormEditchange_follow"); //发送一个change事件
            if (res.code == "200") {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "success",
                });
              }, 300);
              console.log("修改成功!");
            } else {
              setTimeout(() => {
                this.$message({
                  message: res.message,
                  type: "error",
                });
              }, 300);
            }
            //console.log(this.$store.state.count)
          });
        } else {
          console.log("修改失败!");
          return false;
        }
      });
    },
    //删除
    handleDelete(index, row) {
      console.log(row, "row");
      if (row.location != null) {
        return this.$message({
          type: "error",
          message: "该设备已经被绑定，请先解绑后再进行删除!",
        });
      } else {
        this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          center: true,
          closeOnClickModal: false,
        })
          .then(() => {
            console.log(index, row);
            let id = row.id;
            console.log(id);
            this.$postJson("dmc/commonDevice/deleteById/" + id).
              then((res) => {
                if (res.code == 200) {
                  this.$bus.$emit("handleDeletechange_follow"); //发送一个change事件
                  console.log(res);
                  this.$message({
                    type: "success",
                    message: res.message,
                  });
                } else {
                  this.$message({
                    type: "error",
                    message: res.message,
                  });
                }
              });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消删除",
            });
          });
      }
    },
    //关闭新增的dialog
    closexz() {
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //点击新增取消  重置表单以及验证
    cancelxz() {
      this.dialogFormVisible = false;
      this.$refs.form.resetFields(); //移除校验结果并重置字段值
    },
    //新增弹出框点击确定提交信息
    submitForm(datainfo) {
      this.$refs[datainfo].validate((valid) => {
        if (valid) {
          let param = {
            remark: this.form.xzsec,
            deviceName: this.form.xzname,
            deviceNo: this.form.xzdate,
            deviceType: 28
          };
          console.log(param);
          //新增设备
          this.addLoading = true;
          this.$postJson(
            "dmc/commonDevice/add", param)
            .then((res) => {
              console.log(res);
              this.addLoading = false;
              this.dialogFormVisible = false;
              this.$refs.form.resetFields(); //移除校验结果并重置字段值
              this.$bus.$emit("submitFormchange_follow"); //发送一个change事件
              if (res.code == "200") {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "success",
                  });
                }, 300);
                console.log("提交成功!");
              } else {
                setTimeout(() => {
                  this.$message({
                    message: res.message,
                    type: "error",
                  });
                }, 300);
              }

            })
            .catch((res) => {
              this.$message({
                type: "error",
                message: res.message,
              });
            });
        } else {
          console.log("提交失败!");
          return false;
        }
      });
    },
    getTable() {
      this.getTableData();
    },
    //获取表格数据
    getTableData() {
      let param = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        deviceType: this.deviceType,
        deviceNo: this.formInline.inputdeviceno,
      };
      console.log(param);
      this.loading = true;
      this.$postJson("dmc/commonDevice/queryDeviceStatusWithPage", param).then((res) => {
        //判断是否有数据
        if (res.code == 200 && res.result.list.length != 0) {
          this.pageSize = res.result.pageSize;
          this.currentPage = res.result.pageNum;
          this.totalDataNumber = res.result.total * 1;
          this.deviceNo = res.result.list[0].deviceNo;
          // 获取设备在离线状态
          // res.result.list.forEach((item) => {
          //   item.onlineOrOffline = "offline"; // 默认离线
          // });
          this.list = res.result.list;
          this.loading = false;
        } else {
          this.list = [];
          this.totalDataNumber = 0;
          setTimeout(() => {
            this.loading = false;
          }, 600);
        }
      });
    },
    callMohe(index, row){
      console.log(row)
      this.$postJson("dmc/mohe/getToken", {
        deviceId:row.id
      }).then(res=>{
        console.log(res);
        let callToken = res.result;
        console.log(callToken)
      })
    },
    showCallList() {
      let params = {
        pageNum: this.callRecordCurrentPage,
        pageSize: this.callRecordPageSize,
        deviceId: this.currRecordDeviceId,
      };
      this.$postJson("dmc/moheCallRecord/list", params).then((res) => {
        if (res.code == 200) {
          // 处理通话时长总数
          if (res.result.list != null) {
            res.result.list.forEach(item => {
              item.ringingTime = item.ringingTime.replace('.0', '');
              item.answerTime = item.answerTime.replace('.0', '');
              item.hangUpTime = item.hangUpTime.replace('.0', '');
            })
          }

          this.callRecordList = res.result.list; // 拿到所有数据
          this.callRecordTotal = res.result.total * 1;
          this.allTime = ((2 * this.callRecordTotal) / 60).toFixed(0) + 'h' + (2 * this.callRecordTotal) % 60 + 'min';
        } else {
          this.callRecordList = [];
        }
      });
    },
    showLogList(index, row) {
      this.currRecordDeviceNo = row.deviceNo;
      this.logListVisible = true;
    },
    // 查看通话记录
    callRecord(index, row) {
      this.currRecordDeviceId = row.id;
      this.showCallList();
      this.callRecordVisible = true;
    },
    // 获取指定页的数据
    getPageNumList(pageNum, pageSize) {
      this.callRecordCurrentPage = pageNum;
      this.showCallList();
    },
    callRecordHandleCurrentChange(val) {
      this.getPageNumList(val);
    },
    callRecordDialogReset() {},
    handleSizeChange(val) {
      //改变每页显示的条数
      this.PageSize = val;
      this.getTable();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.getTable();
    },
    
  },
  created() {
  },
  mounted() {
    this.getTableData();
  },
};
</script>
<style lang="scss" scoped>
.followlist {
  .followlist-m {
    padding: 10px 0 0 5px;
  }
}

.magicbox ::v-deep .el-dialog__body {
  padding: 0px 20px;
}

.selectAdd {
  width: 200px;
  margin-left: 118px;
  margin-bottom: 10px;
}

// 修改element-ui默认的样式
.del {
  color: red !important;
}

.fangqu {
  color: green !important;
}

.fenye {
  margin: 0;
  padding: 30px 0;
  background: #fff;
}

//  深度作用选择符
.el-dialog__header {
  text-align: left;
  background: rgb(238, 231, 231);
  border-bottom: 2px solid rgb(211, 207, 207);
}

.height40 {
  line-height: 40px;
}

//新增的dialog
@media screen and (min-width: 1200px) {
  .followxz .el-dialog {
    width: 30% !important;
  }
}

//修改的dialog
@media screen and (min-width: 1200px) {
  .followedit .el-dialog {
    width: 30% !important;
  }
}

.transferOption {
  width: 120px !important;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
  font-size: 12px !important;
}
</style>
